import React from 'react';
import { makeStyles,withStyles,useTheme } from '@material-ui/core/styles';
import { IconButton,Tooltip,useMediaQuery  } from '@material-ui/core';
import Icon from '@mdi/react'



import { mdiReact,mdiLanguageCss3,mdiLanguageHtml5,mdiFirebase,mdiMapbox,mdiAngular
        ,mdiBrush ,mdiCubeOutline , 
        mdiGoogle ,mdiAndroid ,
        mdiCamera ,mdiThoughtBubble 
} from '@mdi/js'

var Scroll = require('react-scroll');
var scroller = Scroll.scroller;

const webIcons=[mdiReact,mdiLanguageCss3,mdiLanguageHtml5,mdiFirebase,mdiMapbox,mdiAngular ]
const webIconsText=['React','CSS3','HTML5','Firebase','Mapbox','Angular']

const designIcons = [mdiBrush,mdiCubeOutline ]
const designIconsText = ['Graphic Design','Computer Design']

const googleIcons = [mdiGoogle,mdiAndroid ]
const googleIconsText = ['Google Accelerator','Android']

const otherIcons = [mdiCamera,mdiThoughtBubble  ]
const otherIconsText = ['Photography','Other projects']



const useStyles = makeStyles(theme => ({
    iconButton: {
      margin:'5vh 10px',
      borderRadius: '50px',
        background: '#e7e7e7',
        boxShadow: '8px 8px 17px #c8c8c8, -8px -8px 17px #ffffff',
      '&:active':{
        boxShadow: 'inset 8px 8px 17px #c8c8c8,inset -8px -8px 17px #ffffff',
      }
    },
  }));

  const LightTooltip = withStyles(theme => ({
    tooltip: {
      backgroundColor: 'rgba(255,192,203,0.6)',
      color: 'rgba(0, 0, 0, 0.87)',
      //boxShadow: theme.shadows[1],
      border:'1px solid rgba(0, 0, 0, 0.7)',
      fontSize: 22,
      fontWeight:700,
      fontFamily: `'Yanone Kaffeesatz', sans-serif`
    },
  }))(Tooltip);

  function scrollTo(element){
    scroller.scrollTo(element, {
      duration: 1500,
      smooth: true,
    })
  }
export default function ButtonsLine() {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const iconsSize = matches?1.5:2;
    return (
      <div style={{minHeight:'20vh',width:'100%',textAlign:'center'}}>
        <IconButton className={classes.iconButton} onClick={()=>scrollTo('Web')}>
          {webIcons.map((icon,index) =>
          <LightTooltip title={webIconsText[index]} key={webIconsText[index]} placement="top" arrow>
            <Icon path={icon}
                  size={iconsSize}
                  color="rgba(0, 0, 0, 0.7)"
            />
          </LightTooltip>
            )}
        </IconButton>

        

        <IconButton className={classes.iconButton} onClick={()=>scrollTo('Mobile')}>
          {googleIcons.map((icon,index) =>
            <LightTooltip title={googleIconsText[index]} key={googleIconsText[index]} placement="top" arrow>
              <Icon path={icon}
                    size={iconsSize}
                    color="rgba(0, 0, 0, 0.7)"
              />
          </LightTooltip>
            )}
        </IconButton>

        <IconButton className={classes.iconButton} onClick={()=>scrollTo('ML')}>
          {designIcons.map((icon,index) =>
            <LightTooltip title={designIconsText[index]} key={designIconsText[index]} placement="top" arrow>
              <Icon path={icon}
                    size={iconsSize}
                    color="rgba(0, 0, 0, 0.7)"
                    />
            </LightTooltip>
          )}
        </IconButton>
        
        <IconButton className={classes.iconButton} onClick={()=>scrollTo('Photography')}>
          {otherIcons.map((icon,index) =>
            <LightTooltip key={otherIconsText[index]} title={otherIconsText[index]} placement="top" arrow>
              <Icon path={icon}
                    size={iconsSize}
                    color="rgba(0, 0, 0, 0.7)"
              />
            </LightTooltip>
          )}
        </IconButton>
      </div>   
    );
  }